import React from "react";
import PropTypes from "prop-types";
import styles from "./Banner.module.css";

const SingleBanner = (props) => {
  const { url, external_url, image_url, onClick } = props;

  if (external_url) {
    return (
      <div className={styles.BannerContainer}>
        <a href={url} className={styles.BannerLink} target="_blank" rel="noreferrer">
          <img className={styles.SingleImage} alt={"banner"} src={image_url} />
        </a>
      </div>
    );
  }

  return (
    <div className={styles.BannerContainer} onClick={onClick}>
      <img className={styles.SingleImage} alt={"banner"} src={image_url} />
    </div>
  );
};

SingleBanner.propTypes = {
  url: PropTypes.string,
  external_url: PropTypes.bool,
  image_url: PropTypes.string,
  onClick: PropTypes.func,
};

export default SingleBanner;
